import { Link } from "react-router-dom";
import { aboutData } from "@/mocks/aboutData";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function AboutPage() {
  return (
    <main className="min-h-screen pt-20 pb-16 px-4 md:px-6">
      <div className="max-w-5xl mx-auto w-full">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: "关于我们" },
          ]}
        />

        <section className="mb-16">
          <div className="text-center mb-10">
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-100 mb-3">
              关于风车动漫
            </h1>
            <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              {aboutData.brandIntro}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
            {aboutData.stats.map((stat, i) => (
              <div
                key={stat.label}
                className="text-center p-6 rounded-xl bg-background-800/40 border border-background-700/40"
              >
                <p className="text-2xl md:text-3xl font-bold font-heading text-primary-400">
                  {stat.value}
                </p>
                <p className="text-xs text-foreground-500 mt-1">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-16">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-200 mb-2 text-center">
            使命与愿景
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="p-6 rounded-xl bg-background-800/40 border border-background-700/40">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 mb-4">
                <i className="ri-focus-2-line text-lg"></i>
              </span>
              <h3 className="text-base font-bold text-foreground-200 mb-2">
                我们的使命
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {aboutData.mission}
              </p>
            </div>
            <div className="p-6 rounded-xl bg-background-800/40 border border-background-700/40">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-400 mb-4">
                <i className="ri-eye-line text-lg"></i>
              </span>
              <h3 className="text-base font-bold text-foreground-200 mb-2">
                我们的愿景
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {aboutData.vision}
              </p>
            </div>
          </div>
        </section>

        <section className="mb-16">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-200 mb-2 text-center">
            核心价值观
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
            {aboutData.values.map((v) => (
              <div
                key={v.title}
                className="p-5 rounded-xl bg-background-800/40 border border-background-700/40 text-center"
              >
                <span className="w-12 h-12 flex items-center justify-center mx-auto rounded-full bg-primary-500/10 text-primary-400 mb-3">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="text-sm font-bold text-foreground-200 mb-1.5">
                  {v.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {v.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-16">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-200 mb-2 text-center">
            发展历程
          </h2>
          <div className="mt-8 relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-700/50 hidden sm:block" />
            <div className="space-y-6">
              {aboutData.milestones.map((m, i) => (
                <div
                  key={m.year}
                  className="flex items-start gap-4 sm:gap-6"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 text-background-950 flex items-center justify-center text-xs font-bold relative z-10">
                    {m.year.slice(2)}
                  </div>
                  <div className="flex-1 pt-2">
                    <span className="text-sm font-bold text-foreground-300">
                      {m.year}
                    </span>
                    <p className="text-sm text-foreground-500 mt-1">
                      {m.event}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mb-16">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-200 mb-2 text-center">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8">
            {aboutData.reputation.map((r, i) => (
              <div
                key={i}
                className="p-5 rounded-xl bg-background-800/40 border border-background-700/40"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: r.rating }).map((_, j) => (
                    <span
                      key={j}
                      className="w-4 h-4 flex items-center justify-center text-accent-400"
                    >
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                  「{r.content}」
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={r.avatar}
                      alt={r.author}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <span className="text-xs text-foreground-500 font-medium">
                    {r.author}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-200 mb-2 text-center">
            联系我们
          </h2>
          <div className="mt-8 p-6 rounded-xl bg-background-800/40 border border-background-700/40">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-600 mb-0.5">
                    电子邮箱
                  </p>
                  <p className="text-sm text-foreground-300">
                    {aboutData.contact.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-600 mb-0.5">
                    客服电话
                  </p>
                  <p className="text-sm text-foreground-300">
                    {aboutData.contact.phone}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-600 mb-0.5">
                    公司地址
                  </p>
                  <p className="text-sm text-foreground-300">
                    {aboutData.contact.address}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 flex-shrink-0 mt-0.5">
                  <i className="ri-wechat-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-600 mb-0.5">
                    官方微信
                  </p>
                  <p className="text-sm text-foreground-300">
                    {aboutData.contact.wechat}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于风车动漫",
            description: aboutData.brandIntro,
            about: {
              "@type": "Organization",
              name: "风车动漫",
              description: aboutData.brandIntro,
              url: "https://fengchedongman.com",
              contactPoint: {
                "@type": "ContactPoint",
                email: aboutData.contact.email,
                telephone: aboutData.contact.phone,
                contactType: "customer service",
              },
              address: {
                "@type": "PostalAddress",
                streetAddress: aboutData.contact.address,
                addressCountry: "CN",
              },
            },
          }),
        }}
      />
    </main>
  );
}